"use client"

import { usePrivy } from "@privy-io/react-auth"

export const useAdminAuth = () => {
  const { user, authenticated, login, logout, ready } = usePrivy()

  const walletAddress = user?.wallet?.address as `0x${string}` | undefined

  return {
    user,
    walletAddress,
    authenticated,
    ready,
    login,
    logout,
  }
}
